import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormModal from '../../components/Modals/FormModal';
import InputField from '../../components/Forms/Input/InputField';

interface EditEconomicActivityPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;
  onUpdate: (activityData: { id: number; name: string; code: string }) => void;
  selectedActivity: { id: number; name: string; code: string } | null;
}

const EditEconomicActivityPopup: React.FC<EditEconomicActivityPopupProps> = ({
  popupOpen,
  setPopupOpen,
  onUpdate,
  selectedActivity,
}) => {
  
  // ✅ Validación Yup
  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, 'El nombre debe tener al menos 2 caracteres')
      .required('El nombre de la actividad económica es obligatorio'),

    code: Yup.string()
      .min(2, 'El código debe tener al menos 2 caracteres')
      .max(10, 'Máximo 10 caracteres')
      .required('El código es obligatorio'),
  });

  // ✅ Formik
  const formik = useFormik({
    initialValues: {
      id: selectedActivity?.id || 0,
      name: selectedActivity?.name || '',
      code: selectedActivity?.code || '',
    },
    validationSchema,
    onSubmit: (values) => {
      onUpdate(values);
      setPopupOpen(false);
    },
    enableReinitialize: true,
  });

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Editar Actividad Económica"
      maxWidth="max-w-md"
    >
      <form onSubmit={formik.handleSubmit} className="mt-4">

        {/* Nombre */}
        <InputField
          label="Nombre"
          name="name"
          type="text"
          iconKey='edit'
          placeholder="Ej: Comercialización de productos"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={
            formik.touched.name && formik.errors.name
              ? formik.errors.name
              : undefined
          }
        />

        {/* Código */}
        <InputField
          label="Código"
          name="code"
          type="text"
          iconKey='hash'
          placeholder="Ej: C100"
          value={formik.values.code}
          onChange={formik.handleChange}
          error={
            formik.touched.code && formik.errors.code
              ? formik.errors.code
              : undefined
          }
        />

        <button
          type="submit"
          className="w-full mt-3 rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Cambios
        </button>
      </form>
    </FormModal>
  );
};

export default EditEconomicActivityPopup;
